import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AlertMessage = ({
    content,
    type,
    showIcon,
    icon = 'clock',
    className = 'gi_warning',
    // 'polite' (default) | 'assertive' | 'off'; pass null/false to omit aria-live when nested inside an outer live region.
    ariaLive = 'polite',
}) => {
    return (
        <div className={`grid-row gi_alert__wrap ${className}`}>
            <div className={`usa-alert gi-alert gi-alert__left-accent gi-alert__${type}`}>
                {showIcon && (
                    <div className="gi-alert__icon">
                        <FontAwesomeIcon icon={icon} />
                    </div>
                )}
                <div className="gi-alert__body">
                    <div className="gi-alert__text" aria-live={ariaLive || undefined}>
                        {content}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlertMessage;
